import { generateUuid } from '@helpers/data';

import { WithdrawalsExchangeRatesRecord } from '@types';

import { WithdrawalsAddExchangeRateReducer } from './types';

export const withdrawalsAddExchangeRateReducer: WithdrawalsAddExchangeRateReducer =
  (state) => {
    const newExchangeRate: WithdrawalsExchangeRatesRecord = {
      [generateUuid()]: {
        currency: undefined,
        exchangeRate: undefined,
      },
    };

    return {
      ...state,
      withdrawalsExchangeRatesProcessedItems: {
        ...state.withdrawalsExchangeRatesProcessedItems,
        ...newExchangeRate,
      },
    };
  };
